export const GREEN = "rgb(7, 202, 7)";
export const RED = "rgba(167, 13, 13, 0.9)";
export const BLUE = "rgba(9, 162, 233, 0.9)";